const quantityInputs = document.querySelectorAll(".quantity__input[data-option-lines]");
quantityInputs.forEach(async (input) => {
	input.addEventListener("change", async (event) => {
		let line = parseInt(input.dataset.line);
		let quantity = parseInt(event.target.value);
		let price = parseFloat(input.dataset.valiantPrice);
		let parent_tr = input.closest("tr");
		let total_price = quantity * price;
		let total_price_td = parent_tr.querySelector(".item-line_price");
		total_price_td.textContent = `¥${total_price.toLocaleString()}`;
    await showOverlay();
		await changeJS(line, quantity);
		await optionUpdate(input);
		await setOptionTotal();
		await fetchTotalPrice(input);
    await hideOverlay();
	});
});

const cartRemoveButtons = document.querySelectorAll(".cart-remove-button");
cartRemoveButtons.forEach(async (input) => {
	input.addEventListener("click", async () => {
    await showOverlay();
		let removeData = {};
		if (input.classList.contains("js-group-remove")) {
			let dataGroupIDs = input.dataset.groupIds;
			let groupKeys = dataGroupIDs.split(",");
			groupKeys.forEach(async (key) => {
				removeData[key] = 0;
			});
		} else {
			let itemKey = input.dataset.key;
			removeData[itemKey] = 0;
			if (input.classList.contains("js-item-remove")) {
				let parentTr = input.closest("tr");
				parentTr.querySelector(".quantity__input").value = 0;
				await optionUpdate(input);
				await fetchTotalPrice(input);
				parentTr.remove();
			} else {
				input.closest(".cart-item-option").remove();
				await setOptionTotal();
			}
		}
    await updateJS(removeData);
		window.location.reload();
	});
});

const cartOverlay = document.querySelector('.cart-overlay');
async function showOverlay() {
  cartOverlay.setAttribute('aria-hidden', false);
  cartOverlay.classList.add('is-show');
}
async function hideOverlay() {
  cartOverlay.setAttribute('aria-hidden', true);
  cartOverlay.classList.remove('is-show');
}

async function setTotalPrice() {
	const targetTables = document.querySelectorAll(".js-product-items");
	targetTables.forEach((table) => {
		let dataPriceTds = table.querySelectorAll("[data-price]");
		let totalPriceSpan = table.querySelector(".cart-line_item__total-price");
		let totalPrice = Array.from(dataPriceTds).reduce((sum, td) => {
			let price = parseFloat(td.dataset.price);
			return sum + price;
		}, 0);
		totalPriceSpan.textContent = `¥${totalPrice.toLocaleString()}`;
	});
}

async function optionUpdate(input) {
	let parent_table = input.closest(".js-product-items");
	let newQuantity = 0;
	let targetInputs = parent_table.querySelectorAll(".quantity__input");
	targetInputs.forEach((targetInput) => {
		let input_value = parseFloat(targetInput.value);
		newQuantity += input_value;
	});
	let optionLines = input.dataset.optionLines.split(",").map(Number);
	for (const line of optionLines) {
		const parentContainer = input.closest(".cart-item__contents");
		const targetOptionContainer = parentContainer.querySelector(`.cart-item-option[data-line="${line}"]`);
		if (targetOptionContainer) {
			const targetOptionQuantityTd = targetOptionContainer.querySelector(".item-quantity");
			const targetOptionPriceTd = targetOptionContainer.querySelector(".item-price");
			const targetOptionTotalPriceTd = targetOptionContainer.querySelector(".item-line_price");
			const targetOptionPrice = parseFloat(targetOptionPriceTd.dataset.price);
			const targetOptionTotalPrice = targetOptionPrice * newQuantity;
			targetOptionQuantityTd.textContent = newQuantity;
			targetOptionTotalPriceTd.textContent = `¥${targetOptionTotalPrice.toLocaleString()}`;
      const quantity = newQuantity;
      await changeJS(line, quantity);
		}
	}
}

async function setOptionTotal() {
	const optionTotals = document.querySelectorAll(".js-cart-item-total");
	optionTotals.forEach((optionTotal) => {
		let optionTotalContainer = optionTotal.closest(".cart-item__options");
		let optionSubTotals = optionTotalContainer.querySelectorAll(".item-line_price");
		let optionTotalPrice = 0;
		optionSubTotals.forEach((optionSubTotal) => {
			let optionSubTotalPrice = parseFloat(optionSubTotal.textContent.replace(/[^\d]/g, ""));
			optionTotalPrice += optionSubTotalPrice;
		});
		optionTotal.querySelector(".cart-item-total-price").textContent = `¥${optionTotalPrice.toLocaleString()}`;
	});
}

async function fetchTotalPrice(input) {
	let parent_table = input.closest(".js-product-items");
	let item_line_price = parent_table.querySelectorAll(".item-line_price");
	let item_total_price_span = parent_table.querySelector(".cart-line_item__total-price");
	let item_total_price = Array.from(item_line_price).reduce((sum, item) => {
		let item_price = parseFloat(item.textContent.replace(/[^\d]/g, ""));
		return sum + item_price;
	}, 0);
	item_total_price_span.textContent = `¥${item_total_price.toLocaleString()}`;
	try {
		const response = await fetch("/cart.js");
		const data = await response.json();
		const totalPriceValue = data["total_price"] / 100;
		const totalsTotalValue = document.querySelector(".js-contents .totals__total-value");
		totalsTotalValue.textContent = `¥${totalPriceValue.toLocaleString()}`;
	} catch (error) {
		console.error("Error:", error);
	}
}

async function changeJS(line, quantity) {
  try {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Failed to change cart item quantity. Server response: ${JSON.stringify(errorData)}`);
    }
  } catch (error) {
    console.error("Error:", error.message);
  }
}

async function updateJS(removeData) {
  try {
    const removeResponse = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: removeData }),
    });
    if (!removeResponse.ok) {
      const errorData = await removeResponse.json();
      throw new Error(`Failed to change cart item quantity. Server response: ${JSON.stringify(errorData)}`);
    }
  } catch (error) {
    console.error("Error:", error.message);
  }
}

document.addEventListener("DOMContentLoaded", async function() {
	await setTotalPrice();
	await setOptionTotal();
});